import React from 'react';
import {
	ToothPathology,
	ToothRestoration,
	ToothSurface,
} from '../../../../graphql/graphql';
import DENTToothSurface from '../Tooth/DENTToothSurface';
import { ToothViewData } from '../Tooth/teethData';
import useRestorationSurfaceOutline from '../../Hooks/Tooth/Restoration/useRestorationSurfaceOutline';

interface Props {
	toothViewData: ToothViewData;
	restoration: ToothRestoration;
	surface: ToothSurface;
	pathology?: ToothPathology;
}

const DENTToothRestorationSurface = ({
	toothViewData,
	restoration,
	surface,
	pathology,
}: Props) => {
	const { baseColor, outlineProps } = useRestorationSurfaceOutline({
		quality: restoration.quality,
		material: restoration.material,
		surface,
		pathology,
	});

	return (
		<DENTToothSurface
			toothViewData={toothViewData}
			surface={surface}
			color={baseColor}
			outlineProps={outlineProps}
		/>
	);
};

export default DENTToothRestorationSurface;
